import * as TypesUser from '../types/types_user';
import Vue from 'vue';
import UUID from 'uuid';

export default {
    state: {
        profile: {},
        teachingInfo: {},
        authStatus: {},
        locationInfo: {},
        communicationInfo: { checkBind: false },
        imgConfig: {},
        isTeamPower: {},
        favoritesList: [],
        redDots: {},
        isSmartPlan: null,
        isHaveOldEvaluation: true
    },
    mutations: {
        [TypesUser.USER_SET_PROFILE](state, payload) {
            state.profile = payload || {};
        },
        [TypesUser.USER_SET_AUTH_STATUS](state, payload) {
            state.authStatus = payload || {};
        },
        [TypesUser.USER_SET_IMG_CONFIG](state, payload) {
            state.imgConfig = payload || {};
        },
        [TypesUser.USER_SET_COMMUNICATION](state, payload) {
            if (payload) {
                state.communicationInfo = Object.assign({}, payload, { checkBind: true });
            } else {
                state.communicationInfo = { checkBind: false };
            }
        },
        [TypesUser.USER_SET_TEAM_POWER](state, payload) {
            state.isTeamPower = payload || {};
        },
        [TypesUser.USER_GET_FAVORITES_LIST](state, payload) {
            state.favoritesList = payload;
        },
        [TypesUser.USER_SET_TEACHING_INFO](state, payload) {
            state.teachingInfo = payload;
        },
        [TypesUser.USER_SET_RED_DOTS](state, payload) {
            state.redDots = payload;
        }
    },
    actions: {
    // 获取图片验证码
        [TypesUser.USER_GET_CAPTCHA](ctx, { captchaId }) {
            return Vue.axios({ baseURL: `${feConfig.api.captcha}` }).post('/captcha', {
                apiKey: 'hfs',
                captchaId
            }).then(resp => {
                return Vue.checkResp(resp);
            }).then(data => {
                return data;
            }).catch(err => {
                throw err;
            });
        },
        // 验证图片验证码
        [TypesUser.USER_VERIFY_CAPTCHA](ctx, { captchaId, inputText }) {
            return Vue.axios({ baseURL: `${feConfig.api.captcha}` }).get('/captcha/match-result', {
                params: { apiKey: 'hfs', captchaId, inputText }
            }).then(resp => {
                return Vue.checkResp(resp);
            }).then(data => {
                return data;
            }).catch(err => {
                throw err;
            });
        },
        // 登录
        [TypesUser.USER_POST_LOGIN](ctx, { username, password, rememberMe, reCaptcha, captchaId }) {
            return Vue.http.post('/v2/users/sessions', {
                username,
                password,
                rememberMe,
                reCaptcha,
                captchaId
            }).then(resp => {
                return Vue.checkResp(resp);
            }).then(data => {
                ctx.commit(TypesUser.USER_SET_PROFILE, data);
                return data;
            }).catch(err => {
                ctx.commit(TypesUser.USER_SET_PROFILE, null);
                throw err;
            });
        },
        // 退出
        [TypesUser.USER_DELETE_LOGOUT](ctx) {
            return Vue.http.delete('/v1/users/sessions').then(resp => {
                return Vue.checkResp(resp);
            }).then(data => {
                ctx.commit(TypesUser.USER_SET_PROFILE, null);
                return data;
            }).catch(err => {
                ctx.commit(TypesUser.USER_SET_PROFILE, null);
                throw err;
            });
        },
        // 获取用户基本信息
        [TypesUser.USER_GET_PROFILE](ctx) {
            return Vue.http.get('/v1/user-center/basic-info').then(resp => {
                return Vue.checkResp(resp);
            }).then(data => {
                ctx.commit(TypesUser.USER_SET_PROFILE, data);
                window.user = data.id;
                return data;
            }).catch(err => {
                ctx.commit(TypesUser.USER_SET_PROFILE, null);
                throw err;
            });
        },
        // 获取用户认证状态信息
        [TypesUser.USER_GET_AUTH_STATUS](ctx) {
            return Vue.http.get('/v1/user-center/auth-status').then(resp => {
                return Vue.checkResp(resp);
            }).then(data => {
                ctx.commit(TypesUser.USER_SET_AUTH_STATUS, data);
                return data;
            }).catch(err => {
                ctx.commit(TypesUser.USER_SET_AUTH_STATUS, null);
                throw err;
            });
        },
        // 获取账号通讯信息
        [TypesUser.USER_GET_COMMUNICATION](ctx) {
            return Vue.http.get('/v1/user-center/communication-info').then(resp => {
                return Vue.checkResp(resp);
            }).then(data => {
                ctx.commit(TypesUser.USER_SET_COMMUNICATION, data);
                return data;
            }).catch(err => {
                ctx.commit(TypesUser.USER_SET_COMMUNICATION, null);
                throw err;
            });
        },
        // 获取上传图片配置信息
        [TypesUser.USER_GET_IMG_CONFIG](ctx) {
            return Vue.axios({ baseURL: `${feConfig.api.base}`, withCredentials: true })
                .get('/v1/config/ks3/authorization/post-policy').then(resp => {
                    return Vue.checkResp(resp);
                }).then(config => {
                    ctx.commit(TypesUser.USER_SET_IMG_CONFIG, config);
                    return config;
                }).catch(() => {
                    Vue.handleError('', '上传图片配置信息获取失败');
                    ctx.commit(TypesUser.USER_SET_IMG_CONFIG, null);
                    return {
                        code: 'http error'
                    };
                    // throw err;
                });
        },
        // 是否有查看教学团队权限
        [TypesUser.USER_GET_TEAM_POWER](ctx) {
            return Vue.http.get('/v1/groups/is-leader').then(resp => {
                return Vue.checkResp(resp);
            }).then(data => {
                ctx.commit(TypesUser.USER_SET_TEAM_POWER, data);
                return data;
            }).catch(err => {
                ctx.commit(TypesUser.USER_SET_TEAM_POWER, null);
                throw err;
            });
        },
        // 获取用户收藏夹
        [TypesUser.USER_GET_FAVORITES_LIST](ctx) {
            /**
             * http://wiki.iyunxiao.com/pages/viewpage.action?pageId=318177738#hfsfd-teacher%E6%94%B6%E8%97%8F%E5%A4%B9API-%E8%8E%B7%E5%8F%96%E6%94%B6%E8%97%8F%E5%A4%B9%E5%88%97%E8%A1%A8
             */
            return Vue.http.get('/v1/favorites/list').then(resp => {
                return Vue.checkResp(resp, []);
            }).then(data => {
                ctx.commit(TypesUser.USER_GET_FAVORITES_LIST, data);
                return data;
            }).catch(err => {
                ctx.commit(TypesUser.USER_GET_FAVORITES_LIST, []);
                throw err;
            });
        },
        // 获取教师教学信息
        [TypesUser.USER_GET_TEACHING_INFO](ctx) {
            /**
             * http://wiki.iyunxiao.com/pages/viewpage.action?pageId=40370794#hfsfd-teacher%E7%94%A8%E6%88%B7%E4%B8%AD%E5%BF%83API-%E8%8E%B7%E5%8F%96%E6%95%99%E5%B8%88%E6%95%99%E5%AD%A6%E4%BF%A1%E6%81%AF
             */
            return Vue.http.get('/v1/user-center/teaching-info').then(resp => {
                return Vue.checkResp(resp, []);
            }).then(data => {
                ctx.commit(TypesUser.USER_SET_TEACHING_INFO, data);
                window.subject = data.skilledSubjects[0];
                window.period = data.teachingGrades && Math.floor(data.teachingGrades[0] / 10);
                return data;
            }).catch(err => {
                ctx.commit(TypesUser.USER_SET_TEACHING_INFO, {});
                throw err;
            });
        },
        // 获取作业、测评红点数量
        [TypesUser.USER_GET_RED_DOTS](ctx) {
            // http://wiki.iyunxiao.com/pages/viewpage.action?pageId=40927248#hfsfd-teacher%E8%AF%BE%E8%8A%82API-%E8%8E%B7%E5%8F%96%E4%BD%9C%E4%B8%9A%E3%80%81%E6%B5%8B%E8%AF%84%E7%BA%A2%E7%82%B9%E6%95%B0%E9%87%8F
            return Vue.http.get('/v1/lessons/red-dots').then(resp => {
                return Vue.checkResp(resp, []);
            }).then(data => {
                ctx.commit(TypesUser.USER_SET_RED_DOTS, data);
                return data;
            }).catch(err => {
                ctx.commit(TypesUser.USER_SET_RED_DOTS, {});
                throw err;
            });
        },
        // 上传json字符串至金山云 返回URL
        async [TypesUser.UPLOAD_JSON_RETURN_URL](ctx, payload) {
            if (!payload) return;
            const data = payload;
            let imgConfig = ctx.state.imgConfig;

            if (!imgConfig || !imgConfig.host) {
                await ctx.dispatch(TypesUser.USER_GET_IMG_CONFIG);
                imgConfig = ctx.state.imgConfig;
            }

            let form = {
                name,
                key: UUID.v4(),
                KSSAccessKeyId: imgConfig.ak,
                policy: imgConfig.policy,
                signature: imgConfig.signature,
                keyPrefix: imgConfig.keyPrefix,
                file: data,
                ACL: 'public-read'
            };

            let formData = new FormData();
            formData.append('key', form.keyPrefix + '/' + form.key);
            formData.append('KSSAccessKeyId', form.KSSAccessKeyId);
            formData.append('policy', form.policy);
            formData.append('signature', form.signature);
            formData.append('file', JSON.stringify(form.file));
            formData.append('ACL', form.ACL);

            let hostAddress = imgConfig.host.indexOf('https') > -1 ? imgConfig.host : `https://${imgConfig.host}`;
            return Vue.axios({
                timeout: 0,
                headers: {
                    'Content-Type': 'multipart/form-data; boundary=9431149156168'
                }
            })
                .post(hostAddress, formData)
                .then(() => {
                    let url = '/' + imgConfig.bucket + '/' + form.keyPrefix + '/' + form.key;
                    return Vue.axios({ baseURL: `${feConfig.api.base}`, withCredentials: false })
                        .post('/v1/config/ks3/authorization/urls', {
                            keys: [url]
                        })
                        .then(resp => {
                            return Vue.checkResp(resp);
                        })
                        .catch((err) => {
                            Vue.handleError(err, '上传json数据失败！');
                        });
                });
        },
        // 通过金山云URL 返回数据
        [TypesUser.GET_URL_JSON](ctx, payload) {
            return Vue.axios({
                withCredentials: false
            }).get(payload.url)
                .then(resp => {
                    return resp;
                })
                .catch((err) => {
                    Vue.handleError(err, '获取json数据失败！');
                });
        },
        // 上传课件数据至金山云返回URL
        async [TypesUser.UPLOAD_KEJIAN_JSON_RETURN_URL](ctx, payload) {
            console.log(ctx);
            const urlData = await ctx.dispatch('UPLOAD_JSON_RETURN_URL', payload);
            const resourceUrl = (urlData || { urls: [] }).urls[0];
            return resourceUrl ? resourceUrl + '' : resourceUrl;
        },
        // 获取旧测评数据
        [TypesUser.USER_GET_OLD_EVALUATION](ctx) {
            return Vue.http.get('/v1/stage-evaluation/list').then(resp => {
                return Vue.checkResp(resp, []);
            }).then(data => {
                if (data.total > 0) {
                    ctx.state.isHaveOldEvaluation = true;
                } else {
                    ctx.state.isHaveOldEvaluation = false;
                }
            }).catch(err => {
                throw err;
            });
        }
    },
    getters: {
    // 学生端、家长端登录
        [TypesUser.USER_GET_USER_INFO](state) {
            // 在这可以添加各种逻辑
            return state.profile;
        },
    // 是否显示准备试听规划
        IsShowReadyPlan(state) {
            let info = state.teachingInfo;
            for (let i = 0; i < info.teachingGrades.length; i++) {
                if ([14, 15, 16, 17].includes(info.teachingGrades[i])) {
                    return false;
                }
            }
            return true;
        },
        isShowOldEva(state) {
            return state.isHaveOldEvaluation;
        }
    }
};



// WEBPACK FOOTER //
// ./src/views/index/store/modules/modules_user.js